// @flow
import { Selector } from "src/utils/selectorUtils";
import TrendModel from "src/models/TrendModel";

class SeriesTrendsSelector extends Selector<TrendModel> {}

export default new SeriesTrendsSelector("seriesTrends", new TrendModel());
